import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';
import type { NavSecondaryItem } from '../index';
import { cn } from '@/lib/utils';

interface NavSecondaryProps {
  items: NavSecondaryItem[];
  className?: string;
}

export function NavSecondary({ items, className }: NavSecondaryProps) {
  if (items.length === 0) return null;

  return (
    <SidebarGroup className={cn('pb-1.5 px-6.5', className)}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton
                asChild
                size="sm"
                className="text-sidebar-foreground h-10 rounded-lg"
              >
                <a href={item.url}>
                  <item.icon className="h-3.5 w-3.5" />
                  <span className="text-sm font-medium">{item.title}</span>
                </a>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
